import { inject, Injectable } from '@angular/core';
import { RouteIds, Step } from '../types';
import {
  BuildYourCourseStepDefinitionService,
  ConfirmationStepDefinitionService,
  StepDefinitionStrategy,
  YourInformationStepDefinitionService,
} from './step-definition';

/**
 * Service to get step definitions with proper translation support
 * Following quote-tool-lite pattern - services are instantiated after translations load
 *
 * This service acts as a registry of all step definition strategies,
 * ensuring that $localize calls happen after the translation file is loaded.
 */
@Injectable({
  providedIn: 'root',
})
export class StepsDefinitionService {
  private readonly buildYourCourseStepStrategy = inject(BuildYourCourseStepDefinitionService);
  private readonly yourInformationStepStrategy = inject(YourInformationStepDefinitionService);
  private readonly confirmationStepStrategy = inject(ConfirmationStepDefinitionService);

  private readonly strategies: Record<RouteIds, StepDefinitionStrategy>;

  constructor() {
    // Map each route to its corresponding step definition strategy
    this.strategies = {
      [RouteIds.buildYourCourse]: this.buildYourCourseStepStrategy,
      [RouteIds.yourInformation]: this.yourInformationStepStrategy,
      [RouteIds.confirmation]: this.confirmationStepStrategy,
    };
  }

  /**
   * Gets the step definition for the given step id
   *
   * @param stepId - The route identifier for the step
   * @returns The step definition with translated content
   */
  getStepDefinition(stepId: RouteIds): Step {
    return this.strategies[stepId].getStepDefinition();
  }
}
